import React from 'react';

const Players = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold text-gray-800">Players</h1>
      {/* Add your players content here */}
    </div>
  );
};

export default Players; 